import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Input,
  Row,
  Table,
  Col,
  Progress,
} from 'reactstrap';
import { IconButton, Typography } from '@mui/material';

import BackupIcon from '@mui/icons-material/BackupOutlined';
import CloseIcon from '@mui/icons-material/Close';
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';
// import { makeStyles } from '@mui/icons-material//styles';
import NotificationAlert from 'react-notification-alert';
import Papa from 'papaparse';
import firebase from 'firebase';
import CardHeader from 'reactstrap/lib/CardHeader';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import { CSVLink } from 'react-csv';
import GetAppIcon from '@mui/icons-material/GetApp';
import _ from 'lodash';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     '& :hover': {
//       //   backgroundColor:'white'
//     },
//     color: '#FFF',
//   },
//   dialog: {
//     '& .MuiDialogTitle-root': {
//       backgroundColor: '#FFF',
//       color: '#333333',
//     },
//     '& .MuiDialogActions-root': {
//       backgroundColor: '#FFF',
//       color: '#333333',
//     },
//   },
//   dialogBtn: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     backgroundColor: '#FFF',
//   },
//   title: {
//     '& .MuiDialogTitle-root': {
//       color: '#333333',
//     },
//   },
// }));
const functions = firebase.functions();

function MediaDialog({ setIsBulkUpload }) {
  const createBulkStudents = functions.httpsCallable('createBulkStudents');

  const classes = {
    root: {
      '& :hover': {
        //   backgroundColor:'white'
      },
      color: '#FFF',
    },
    dialog: {
      '& .MuiDialogTitle-root': {
        backgroundColor: '#FFF',
        color: '#333333',
      },
      '& .MuiDialogActions-root': {
        backgroundColor: '#FFF',
        color: '#333333',
      },
    },
    dialogBtn: {
      display: 'flex',
      justifyContent: 'space-around',
      backgroundColor: '#FFF',
    },
    title: {
      '& .MuiDialogTitle-root': {
        color: '#333333',
      },
    },
  };
  const [progressVisible, setProgressVisible] = useState(true);
  const [result, setResult] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [haveCourseError, setHaveCourseErr] = useState([]);
  const [differData, setDifferData] = useState([]);
  const [difference, setDifference] = useState(false);
  const [fileName, setFileName] = useState('');
  const [progressValue, setProgressValue] = useState(8);
  const browseBtnRef = useRef();
  let data = [];

  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const csvJSON = async (e) => {
    console.log('e', e.target.files);
    let files = e.target.files;
    if (!files && files.length === 0) {
      return notify('Please try again', true);
    }

    let packageData = await db
      .collection('zSystemStore')
      .where('type', '==', 'package')
      .get()
      .then((query) => {
        let data = {};
        query.docs.forEach((doc) => {
          let docData = doc.data();
          data = { ...data, [docData.title]: docData.itemID };
        });
        return data;
      });

    console.log('packageData', packageData);
    setFileName(files[0]?.name);
    Papa.parse(files[0], {
      header: true,
      complete: function (results) {
        console.log('complete', results);
        if (results.data.length !== 0) {
          // console.log("ssdsdsd");
          console.log(
            'ssdsdsd',
            results.data[0].firstname !== undefined &&
              results.data[0].secondaryEmail !== undefined &&
              results.data[0].email !== undefined &&
              results.data[0].address !== undefined &&
              results.data[0].enrolled !== undefined &&
              results.data[0].lastname !== undefined &&
              results.data[0].mobile !== undefined &&
              results.data[0].password !== undefined &&
              results.data[0].status !== undefined &&
              results.data[0].gender !== undefined &&
              results.data[0].marksofCTET !== undefined &&
              results.data[0].motherName !== undefined &&
              results.data[0].professionalQualification !== undefined &&
              results.data[0].professionalQualificationPassingYear !==
                undefined &&
              results.data[0].secondaryEmail !== undefined &&
              results.data[0].Courses !== undefined &&
              results.data[0].shift !== undefined &&
              results.data[0].category !== undefined &&
              results.data[0].dateofBirth !== undefined &&
              results.data[0].educationalQualification !== undefined &&
              results.data[0].educationalQualificationPassingYear !==
                undefined &&
              results.data[0].fatherGuardianOccupation !== undefined &&
              results.data[0].fatherName !== undefined
          );

          if (
            results.data[0].firstname !== undefined &&
            results.data[0].secondaryEmail !== undefined &&
            results.data[0].email !== undefined &&
            results.data[0].address !== undefined &&
            results.data[0].enrolled !== undefined &&
            results.data[0].lastname !== undefined &&
            results.data[0].mobile !== undefined &&
            results.data[0].password !== undefined &&
            results.data[0].status !== undefined &&
            results.data[0].gender !== undefined &&
            results.data[0].marksofCTET !== undefined &&
            results.data[0].motherName !== undefined &&
            results.data[0].professionalQualification !== undefined &&
            results.data[0].professionalQualificationPassingYear !==
              undefined &&
            results.data[0].secondaryEmail !== undefined &&
            results.data[0].Courses !== undefined &&
            results.data[0].shift !== undefined &&
            results.data[0].category !== undefined &&
            results.data[0].dateofBirth !== undefined &&
            results.data[0].educationalQualification !== undefined &&
            results.data[0].educationalQualificationPassingYear !== undefined &&
            results.data[0].fatherGuardianOccupation !== undefined &&
            results.data[0].fatherName !== undefined
          ) {
            // console.log("ssdsdsd");
            let haveCourseErr = [];
            let finalData = results.data.map((item) => {
              return {
                ...item,
                Courses: item.Courses?.split(',')
                  .map((mItem) => {
                    if (!mItem) return;
                    if (!packageData[mItem]) {
                      console.log('in IF ', packageData[mItem]);
                      haveCourseErr.push({
                        email: item.email,
                        mobile: item.mobile,
                        errDetail: 'Course not available',
                      });
                      return null;
                    } else return packageData[mItem];
                  })
                  .filter((item) => item),
                enrolled: Boolean(item.enrolled),
              };
            });
            console.log(finalData, haveCourseErr);
            finalData = finalData.filter(
              (item) =>
                item.email !==
                haveCourseErr.find((fItem) => fItem.email === item.email)?.email
            );
            console.log('finalData', finalData);
            let output = _.uniqBy(finalData, 'email');
            console.log('finalData2', output);
            let diff = _.difference(finalData, output);
            console.log('diff', diff);
            if (diff?.length !== 0) setDifference(true);
            setDifferData(diff);
            setHaveCourseErr(haveCourseErr);
            setCsvData(finalData);
          } else {
            setCsvData([]);
            setHaveCourseErr([]);
            notify('Please upload file with correct field names');
          }
        }
        // setErrorData(results.data)
        // createBulkStudents({studentsData: results.data}).then(res=>{
        //   console.log('response',res)
        // })
      },
      error: (err) => {
        console.log('err', err);
      },
    });
  };

  const onSubmit = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    createBulkStudents({ studentsData: csvData }).then((res) => {
      console.log('response', res);
      if (res.data && res.data.length !== 0) {
        setErrorData(res.data?.filter((item) => item.hasError === true));
        notify('Student updated', false);
        setResult(true);
        document.querySelector('#loading-indicator').style.display = 'none';
      }
    });
  };

  const headers = [
    { label: 'firstname', key: 'firstname' },
    { label: 'lastname', key: 'lastname' },
    { label: 'mobile', key: 'mobile' },
    { label: 'whatsapp', key: 'whatsapp' },
    { label: 'email', key: 'email' },
    { label: 'password', key: 'password' },
    { label: 'enrollmentNO', key: 'enrollmentNO' },
    { label: 'fatherName', key: 'fatherName' },
    { label: 'motherName', key: 'motherName' },
    { label: 'gender', key: 'gender' },
    { label: 'husbandName', key: 'husbandName' },
    { label: 'fatherGuardianOccupation', key: 'fatherGuardianOccupation' },
    { label: 'address', key: 'address' },
    { label: 'addresspinCode', key: 'addresspinCode' },
    { label: 'dateofBirth', key: 'dateofBirth' },
    { label: 'category', key: 'category' },
    { label: 'Courses', key: 'Courses' },
    { label: 'shift', key: 'shift' },
    { label: 'educationalQualification', key: 'educationalQualification' },
    {
      label: 'educationalQualificationPassingYear',
      key: 'educationalQualificationPassingYear',
    },
    { label: 'professionalQualification', key: 'professionalQualification' },
    {
      label: 'professionalQualificationPassingYear',
      key: 'professionalQualificationPassingYear',
    },
    { label: 'marksofCTET', key: 'marksofCTET' },
    { label: 'secondaryEmail', key: 'secondaryEmail' },
    { label: 'enrolled', key: 'enrolled' },
    { label: 'status', key: 'status' },
  ];
  const csvData2 = [
    {
      firstname: 'MINI',
      lastname: 'YADAV',
      mobile: 8377720778,
      whatsapp: 8377720778,
      email: 'miniyadv1@gmail.com',
      password: 'tncc@123',
      enrollmentNO: 'K1254',
      fatherName: 'Ramesh',
      motherName: '',
      gender: 'female',
      husbandName: '',
      fatherGuardianOccupation: '',
      address: '',
      addresspinCode: '110011',
      dateofBirth: '01-Jan-2001',
      category: 'OBC',
      educationalQualification: '12th',
      educationalQualificationPassingYear: '2015',
      professionalQualification: 'B.Ed',
      professionalQualificationPassingYear: '2020',
      marksofCTET: '49',
      secondaryEmail: 'K1254@tncollege.online',
      Courses: 'TGT ENGLISH,NURSERY TEACHERS',
      shift: 'Morning',
      enrolled: 'true',
      status: 'Active',
    },
    {
      firstname: 'MIMI',
      lastname: 'YADAV',
      mobile: 8377720779,
      whatsapp: 8377720779,
      email: 'miniyadv2@gmail.com',
      password: 'tncc@123',
      enrollmentNO: 'K1255',
      fatherName: 'Ramesh',
      motherName: '',
      gender: 'female',
      husbandName: '',
      fatherGuardianOccupation: '',
      address: '',
      addresspinCode: '110011',
      dateofBirth: '01-Jan-2001',
      category: 'General',
      educationalQualification: '10th',
      educationalQualificationPassingYear: '2014',
      professionalQualification: 'BE',
      professionalQualificationPassingYear: '2020',
      marksofCTET: '87',
      secondaryEmail: 'K1255@tncollege.online',
      Courses: 'TGT ENGLISH,NURSERY TEACHERS',
      shift: 'Afternoon',
      enrolled: 'true',
      status: 'Inactive',
    },
  ];
  useEffect(() => {
    console.log('errorData', errorData);
  }, [errorData]);

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >
      {/* {progressVisible && (
        <Progress color="info" value={progressValue} style={{ height: 4 }} />
      )} */}
      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notifi} />
      </div>
      <div style={{ padding: '5px 20px', marginBottom: 150 }}>
        <Row style={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge='start'
            style={{ color: 'white' }}
            onClick={() => {
              setIsBulkUpload((prev) => !prev);
              // handleDialogClose();
            }}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </Row>

        <Row>
          <Col md='12'>

          </Col>
        </Row>
        {csvData && csvData.length !== 0 && !result && !difference && (
          <Row
            style={{
              position: 'fixed',
              bottom: '0',
              // marginLeft: "0px",
              marginRight: '0px',
              minHeight: '60px',
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              left: '-10',
              backgroundColor: '#272a3d',
            }}
          >
            <Row
              style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Col sm={2}>
                <Button color='info' type='submit' onClick={onSubmit}>
                  Submit
                </Button>
              </Col>
            </Row>
          </Row>
        )}
      </div>
    </div>
  );
}

export default MediaDialog;
